import { CfAsset } from 'ggApp/modules/contentful/models/asset';

export function mapCfEntityToCfMarketingCard(cfEntity = {}) {
    const { fields } = cfEntity;

    const result = {};

    const {
        cardTitle: title,
        cardDescription: description,
        cardCtaText: ctaText,
        ctaLink,
        cardImage: image,
    } = fields || {};

    Object.assign(result, {
        title,
        description,
        ctaText,
        ctaLink,
        image: image && CfAsset.mapCfEntity(image),
    });

    return result;
}
